/**
 * @flow
 */

import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { get } from 'lodash';

import { setMaster } from '../../../actions/master-appointments';
import { MasterSelect } from '../../appointments';

// `master` is stripped so it doesn't leak onto the underlying Select.
function MasterSelectContainer({ master, ...props }) {
    const dispatch = useDispatch();
    const value = useSelector(({ masterAppointments }) =>
        get(masterAppointments.get('master'), 'id'),
    );

    const onChange = useCallback(
        (e, { value: selected }) => {
            dispatch(setMaster({ id: selected }));
        },
        [dispatch],
    );

    return <MasterSelect {...props} value={value} onChange={onChange} />;
}

export default MasterSelectContainer;
